import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M49.3199 14.0218C49.3199 14.0218 47.77 7.1018 39.77 2.9818C32.06 -0.978199 25.5699 3.97179 25.5699 3.97179C25.5699 3.97179 21.7199 2.87179 17.3099 4.19179C11.9099 5.81179 10.7599 10.3018 10.7599 10.3018C10.7599 10.3018 7.06995 11.8418 4.31995 17.0718C2.00995 21.4718 1.67993 24.6718 1.67993 30.9418C1.67993 37.2118 3.43994 46.4618 3.43994 46.4618C6.07994 46.2418 8.05994 55.6018 8.05994 55.6018C10.9199 50.8718 9.48991 42.6118 9.59991 34.1318C9.70991 25.6518 14.2199 22.6818 14.2199 22.6818C16.6399 21.4718 20.2499 21.3618 20.2499 21.3618C21.8199 28.6318 27.0999 28.0818 27.0999 28.0818C25.3399 23.3518 25.89 21.0318 25.89 21.0318C35.61 20.0418 47.08 22.3518 47.08 22.3518C47.08 22.3518 53.02 24.0818 53.08 34.1318C53.13 42.6118 51.7599 50.8618 54.6199 55.6018C54.6199 55.6018 56.5999 46.2418 59.2399 46.4618C59.2399 46.4618 61.03 37.7918 61.03 31.5218C61.03 25.2418 61.1199 21.2118 58.3599 17.0718C55.0099 12.0418 49.3199 14.0218 49.3199 14.0218Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M38.4399 14.7618C36.7199 13.3918 34.6799 12.5318 32.7799 12.7718C32.5499 12.7918 32.3099 12.8418 32.0699 12.9118L31.3598 13.0818C30.9198 13.2818 30.4599 13.4018 30.0699 13.6818C29.2399 14.1318 28.5399 14.7918 27.9899 15.5718C26.8099 17.1018 26.2498 19.1018 26.0398 21.1318C25.8698 23.1818 26.1399 25.2918 26.7699 27.4118C25.3899 25.6718 24.5998 23.4118 24.4798 21.1018C24.3798 18.7918 24.9199 16.3618 26.3899 14.3818C27.8099 12.3918 30.3098 11.1118 32.7298 11.2118C35.2598 11.2618 37.3599 12.8618 38.4399 14.7618Z"
        fill={outline}
      />
      <path
        d="M24.4598 7.82178C23.4198 9.59178 22.6698 11.4118 22.1198 13.2618C21.5898 15.1118 21.3098 17.0218 21.2998 18.9118C21.3098 20.7918 21.5898 22.6818 22.3598 24.3518C23.1298 26.0218 24.4898 27.4018 26.4398 28.1318C25.4098 28.1818 24.3398 27.9218 23.3798 27.3818C22.4298 26.8318 21.6098 26.0418 21.0098 25.1118C19.7998 23.2518 19.3098 21.0418 19.2998 18.9018C19.2998 16.7518 19.7798 14.6318 20.6598 12.7118C21.5398 10.8118 22.7898 9.05178 24.4598 7.82178Z"
        fill={outline}
      />
      <path
        d="M37.26 20.8718C37.26 20.8718 36.18 15.7018 32.88 15.5018C28.83 15.2518 28.5 20.2118 28.5 20.2118"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M43.6199 17.6518C43.2699 16.5618 42.7899 15.5218 42.2299 14.5318C41.6799 13.5418 41.0199 12.6118 40.2599 11.7818C39.4999 10.9518 38.6499 10.2018 37.6699 9.66184C37.1999 9.35184 36.6699 9.17184 36.1599 8.95184C35.6199 8.81184 35.0999 8.61183 34.5399 8.56183L33.7099 8.43183C33.4299 8.41183 33.1499 8.41184 32.8699 8.41184C32.3099 8.36184 31.7599 8.48183 31.2099 8.53183C30.1199 8.75183 29.0599 9.14183 28.0899 9.69183C26.1699 10.8418 24.5499 12.5418 23.3899 14.5018C24.3899 12.4518 25.9299 10.6218 27.8899 9.36182C28.8699 8.73182 29.9899 8.33182 31.1299 8.08182C31.7099 8.02182 32.2899 7.89183 32.8799 7.93183C33.1699 7.94183 33.4699 7.93183 33.7599 7.94183L34.6299 8.07184C35.2099 8.13184 35.7699 8.34183 36.3299 8.50183C36.8599 8.74183 37.4199 8.94182 37.9099 9.27182C38.9199 9.86182 39.8199 10.6318 40.5599 11.5318C42.0499 13.3018 43.0599 15.4318 43.6199 17.6518Z"
        fill={outline}
      />
      <path
        d="M44.3599 14.8418C43.8499 13.7118 43.2499 12.6318 42.5499 11.6218C41.8699 10.6118 41.1199 9.64184 40.2399 8.81184C38.4999 7.15184 36.4099 5.85183 34.0599 5.43183C31.7299 4.95183 29.2599 5.07183 26.9799 5.80183C25.8399 6.17183 24.7398 6.70182 23.7198 7.36182C22.6798 8.00182 21.7399 8.80184 20.8999 9.72184C22.2499 7.62184 24.3599 6.03183 26.7099 5.08183C27.8899 4.59183 29.1599 4.36184 30.4299 4.22184C31.0699 4.20184 31.7099 4.15184 32.3499 4.22184L33.3099 4.29185L34.2599 4.46183C36.8099 4.94183 39.0999 6.41185 40.7899 8.29185C42.4899 10.1818 43.7199 12.4418 44.3599 14.8418Z"
        fill={outline}
      />
      <path
        d="M35.28 20.7919C35.28 20.7919 35.11 17.1619 32.64 17.1619C30.16 17.1619 29.75 20.2219 29.75 20.2219"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M1.66992 28.7117C1.66992 28.7117 6.70991 26.1517 9.59991 20.9517C12.4899 15.7517 14.55 3.61171 24.96 4.35171"
        stroke={outline}
        strokeWidth="0.75"
        strokeMiterlimit="10"
      />
      <path
        d="M1.91992 24.8319C1.91992 24.8319 5.95992 22.6019 8.60992 18.4719C11.9999 13.1919 10.3399 7.16188 17.1099 4.93188"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M20.66 14.9319C20.66 14.9319 18.35 19.3519 11.25 23.5219C1.67001 29.1319 2.41999 38.7119 2.41999 38.7119"
        stroke={outline}
        strokeMiterlimit="10"
      />
      <path
        d="M10.37 30.5017C10.37 30.5017 4.65002 33.5817 2.77002 41.5117"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M9.38 35.2417C9.38 35.2417 5.08999 37.9917 2.98999 43.2817"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M52.3198 30.5017C52.3198 30.5017 58.0398 33.5817 59.9198 41.5117"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M53.3101 35.2417C53.3101 35.2417 57.6001 37.9917 59.7001 43.2817"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M46.0999 21.2818C47.0299 20.0218 48.3199 18.9719 49.8599 18.3919C51.3899 17.7919 53.1799 17.7719 54.7399 18.3919C56.3299 18.9919 57.5899 20.3418 58.1899 21.8618C58.8199 23.3818 58.9499 25.0218 58.7299 26.5818C58.5699 25.0218 58.1699 23.5118 57.4899 22.1918C56.7999 20.8818 55.7299 19.8218 54.3799 19.3218C53.0399 18.7818 51.5299 18.7418 50.0999 19.1318C48.6699 19.5418 47.3099 20.2918 46.0999 21.2818Z"
        fill={outline}
      />
      <path
        d="M50.1399 24.0919C50.1399 24.0919 58.3999 22.8519 60.6299 34.1619"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M46.26 18.1517C46.27 17.1417 46.67 16.2017 47.23 15.3617C47.81 14.5317 48.63 13.8317 49.59 13.4017C50.55 12.9617 51.65 12.7917 52.67 12.9817C53.18 13.0217 53.66 13.2517 54.12 13.4217C54.57 13.6517 54.98 13.9317 55.34 14.2617C54.33 14.3817 53.47 14.3717 52.65 14.5517C51.84 14.6617 51.11 14.9117 50.41 15.2217C49.01 15.8417 47.76 16.8817 46.26 18.1517Z"
        fill={outline}
      />
    </g>
  )
}
